// Resolves the backend origin without needing it baked in at build time. Prefers
// VUE_APP_API_URL when set (local dev's .env.development pins http://localhost:8001, since
// frontend/backend aren't on subdomains of a shared domain there). Otherwise derives it from
// the deployed convention (see lms/CLAUDE.md "Deployment (DigitalOcean)"): the frontend is
// always served at app.<domain>, the backend at api.<domain> — so one production build works
// on any domain without rebuilding.
const apiBaseUrl = (): string => {
  if (process.env.VUE_APP_API_URL) {
    return process.env.VUE_APP_API_URL;
  }
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname.replace(/^app\./, "api.")}`;
};

export const getRequest = <T>(path: string, token: string): Promise<T> => {
  const url = apiBaseUrl() + "/api/v1/" + path;

  const headers = new Headers({
    Authorization: `Token ${token}`,
  });

  return fetch(url, {
    method: "GET",
    headers: headers,
  }).then((response) => response.json());
};

export const postRequest = <T>(
  path: string,
  body: Record<string, unknown>,
  token: string
): Promise<T> => {
  const url = apiBaseUrl() + "/api/v1/" + path;

  const headers = new Headers({
    Authorization: `Token ${token}`,
    "Content-Type": "application/json",
  });

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: headers,
  }).then((response) => response.json());
};

export const postFormRequest = <T>(
  path: string,
  formData: FormData,
  token: string
): Promise<T> => {
  const url = apiBaseUrl() + "/api/v1/" + path;

  // No Content-Type here on purpose: the browser sets it (including the multipart boundary)
  // itself from the FormData body. Setting it manually breaks the boundary and the server
  // can't parse the request.
  const headers = new Headers({
    Authorization: `Token ${token}`,
  });

  return fetch(url, {
    method: "POST",
    body: formData,
    headers: headers,
  }).then((response) => response.json());
};

export const getToken = (
  username: string,
  password: string
): Promise<{ token: string; must_change_password: boolean }> => {
  // define path to get the token
  const url = apiBaseUrl() + "/api/v1/token-auth";
  const formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);

  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" }, // have to say what format of data  you're sending
    body: JSON.stringify({ username, password }), // this is the data you're sending
  }).then((response) => response.json());
};
